<template>
  <div class="forget_account">
    <div class="content_a">
      <span>当前注册的账号：</span>
      <div class="account">{{ phone }}</div>
    </div>
    <div class="content_a">
      <span>短信验证码：</span>
      <el-input
        placeholder="请输入验证码"
        class="input2"
        prefix-icon="el-icon-s-promotion"
        v-model.trim="msmcode"
      >
      </el-input>

      <div class="vertify_c" v-if="send" @click="fasong()">获取验证码</div>
      <div class="vertify_c" v-if="sende">{{ num }}秒后重新获取</div>
      <div class="vertify_c" v-if="sended" @click="refasong()">
        重新获取验证码
      </div>
    </div>
    <el-button type="primary" class="forget_btn" @click="checkmsm"
      >下一步</el-button
    >
  </div>
</template>

<script>
import forget from "@/api/forgetpassword";
import qs from "qs";
export default {
  data() {
    return {
      input2: "",
      send: true,
      sende: false,
      sended: false,
      phone: "",
      num: 60,
      timer: "",
      sendmsmguid: "", //第一次短信返回的guid
      msmcode: "", //输入的短信验证码
    };
  },
  props: ["cutcom"],
  methods: {
    async fasong() {
      let parmars = {
        guid: this.$parent.guid, //全局认证码
        phone: this.phone,
      };
      let res = await forget.sendMsg(parmars);
      if (res.data.Status == 201) {
        this.$message({
          showClose: true,
          message: "请60s后重新获取",
          type: "error",
        });
      }
      this.sendmsmguid = res.data.Data.guid;
      console.log(res);
      this.send = false;
      this.sende = true;
      this.timer = setInterval(() => {
        if (this.num !== 0) {
          this.num -= 1;
        } else {
          this.sende = false;
          this.sended = true;
          this.num = 60;
          clearInterval(this.timer);
        }
      }, 1000);
      // 发送验证码
      // this.getInfoCode();
    },
    refasong() {
      this.send = false;
      this.sende = true;
      this.sended = false;
      this.timer = setInterval(() => {
        if (this.num !== 0) {
          this.num -= 1;
        } else {
          this.sende = false;
          this.sended = true;
          this.num = 60;
          clearInterval(this.timer);
        }
      }, 1000);
      // 再次发送验证码
      this.fasong();
    },
    async checkmsm() {
      //校验短信验证码
      let parmas = {
        phone: this.$parent.phone,
        guid: this.sendmsmguid,
        sms: this.msmcode,
      };
      let res = await forget.checkMsg(qs.stringify(parmas));
      console.log(res);
      if (res.data.Status == 200) {
        console.log("通过短信校验");
        this.$message({
          showClose: true,
          message: "短信验证成功",
          type: "success",
        });
        this.$parent.guid = res.data.Data.guid; //验证成功后，刷新父组件的guid
        this.cutcom(2);
      } else {
        this.$message({
          showClose: true,
          message: "验证码输入错误",
          type: "error",
        });
      }
    },
  },
  created() {
    this.phone = this.$parent.phone;
  },
};
</script>

<style lang="less" scoped>
.forget_account {
  width: 540px;
  height: 300px;
  // background: red;
  .content_a {
    display: flex;
    align-items: center;
    //  justify-content: center;
    margin-top: 40px;
    span {
      width: 150px;
      // text-align: right;
      font-weight: 600;
      color: #333333;
      font-weight: bold;
    }
    .phone {
      width: 400px;
    }
    .account {
      font-size: 18px;
      font-weight: 600;
      color: orangered;
    }
  }
}

.input2 {
  width: 240px;
}

.vertify_c {
  //  background: chocolate;
  width: 140px;
  margin-left: 10px;
  color: #409eff;
  font-weight: 400;
  cursor: pointer;
}

.forget_btn {
  margin-top: 10px;
  width: 300px;
  margin: 60px 150px;
}
</style>
